import { Fragment } from "react";
import { Link } from "react-feather";
import { LinksData } from "../../../../Data/Messenger/Messenger";
import { dynamicImage, Image } from "../../../../Utils";

const Links = () => {
  return (
    <Fragment>
      {LinksData.map((link, index) => (
        <div className="link-group" key={index}>
          <div className="d-flex">
            <Link/>
            <div className="flex-grow-1">
              <h6 className="mt-0">{link.title}</h6>
              <p>{link.time}</p>
            </div>
          </div>
          <a href={link.href}>{link.href}</a>
          <div className="d-flex">
            <Image className="img-fluid" src={dynamicImage(link.imgSrc)} alt="media-img" />
            <div className="flex-grow-1">
              <h6>{link.subtitle}</h6>
              <p className="mt-0">{link.description}</p>
            </div>
          </div>
        </div>
      ))}
    </Fragment>
  );
};

export default Links;
